import { TextField } from '@maas-components/core'
import DEFAULT_THEME from '@maas-components/styles'
import styled from 'styled-components'

export const StyledTextField = styled(TextField)`
  position: relative;

  & [class*='MuiFormHelperText-contained'] {
    position: absolute;
    bottom: -21px;
    min-width: 180px;
    margin-left: 12px;
    margin-right: 12px;
  }

  & .MaasProduct-MuiInputBase-input {
    padding: ${({ placeholder }) => (placeholder ? '14.5px 24px 14.5px' : '')};
  }
`

export const HelperTextWrapper = styled.span`
  & > span {
    display: flex;
    color: ${DEFAULT_THEME.palette.grey[500]};
  }

  & svg {
    font-size: 16px;
    margin-right: 4px;
  }
`
